
import { Component, Mixins } from "vue-property-decorator";
import { ReferenceFileInformation } from "../../../../domain/document";
import { EditingDocument } from "..";

@Component
export default class ReferenceFileAccessibleMixin extends Mixins() {
  readPropertyOrDefault: <T>(reader: (source: EditingDocument) => T, defaultValue: T) => T;

  get referenceFiles(): ReferenceFileInformation[] {
    return this.readPropertyOrDefault(s => s.referenceFiles, []);
  }

  get hasReferenceFile(): boolean {
    if (!this.referenceFiles) { return false; }
    if (this.referenceFiles.length === 0) { return false; }
    return true;
  }
}
